module.exports = __webpack_public_path__ + "static/media/naa-logo.8d7132ae.webp";